import React, { FC, memo, useState } from 'react';
import { useRequest } from 'ahooks';
import { Select } from 'udesk-ui';
import { SelectProps } from 'udesk-ui/lib/select';
import { getUsers } from 'src/api/users';
import UdeskLocales from 'UdeskLocales';

interface TemplateProps extends SelectProps<number> {}

const Template: FC<TemplateProps> = memo((props) => {
    const { ...restProps } = props;

    const [options, setOptions] = useState<{ label: string; value: number }[]>([]);

    const { run } = useRequest(
        (keyword?: string) =>
            getUsers({
                params: {
                    pageNum: 1,
                    pageSize: 100,
                    keyword,
                },
            }),
        {
            onSuccess: (res) => {
                setOptions(
                    res.data?.map((item) => {
                        return {
                            label: item.realname!,
                            value: item.id!,
                        };
                    }) || []
                );
            },
        }
    );

    return (
        <Select
            options={options}
            showSearch
            filterOption={false}
            onSearch={(v) => run(v)}
            placeholder={/* 请选择 */UdeskLocales['current'].components.userSelect.index.pleaseSelect}
            {...restProps}
        />
    );
});

export default Template;
